export default __webpack_public_path__ + "static/safety-14c9a9c57a8c8bedfb9c0fe53f089ed7.png";